export default {
    props: {
        isEditing: {
            type: Boolean,
            default: false
        },
        lng: {
            default () {
                return '103.81599968947137';
            }
        },
        lat: {
            default () {
                return '30.78152098571051';
            }
        },
        zoom: {
            type: Number,
            default () {
                return 10.5;
            }
        },
        zoomMin: {
            type: Number,
            default () {
                return 5;
            }
        },
        zoomMax: {
            type: Number,
            default () {
                return 19;
            }
        },
        //工具条
        zoomTool: {
            type: Boolean,
            default: true
        },
        //鼠标放大
        mouseZoom: {
            type: Boolean,
            default: true
        },
        //地图拖拽
        drag: {
            type: Boolean,
            default: true
        },
         //地图样式
        mapStyle: {
            default: null
        },
        isLabelText: {
            type: Boolean,
            default: true
        },
        api: {
            type: String,
            default: `../default-data/point-data.json`,
        },
        scale: {
            default () {
                return 1;
            }
        },
        showMap: {
            type: Boolean,
            default: true
        },
        gradient: {
            type: Object,
            default () {
                return {
                    0.55: 'rgb(0,255,0)',
                    0.85: 'yellow',
                    1.0: 'rgb(255,0,0)'
                }
            }
        },
        radius: {
            type: Number,
            default: 17
        },
        maxValue: {
            type: String,
            default: ""
        },
        opacity: {
            type: Number,
            default: 1
        }

    }
}